import styled from 'styled-components'

export const TableWrap = styled.div`
  overflow-x: auto;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

export const Th = styled.th`
  padding: 10px 12px;
  text-align: left;
  color: #a1a1a1;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`

export const StickyTh = styled(Th)`
  position: sticky;
  left: 0;
  z-index: 2;
  background: #111;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
`

export const Td = styled.td`
  padding: 10px 12px;
  color: #a0a0a0;
  font-size: 13px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);

  tr:last-child & { border-bottom: none; }
`

export const AccentTd = styled(Td)`
  color: #ededed;
  font-weight: 500;

  a {
    color: #ededed;
    &:hover { color: #a89aff; text-decoration: underline; }
  }
`

export const StickyAccentTd = styled(AccentTd)`
  position: sticky;
  left: 0;
  z-index: 1;
  background: #0a0a0a;
  border-right: 1px solid rgba(255, 255, 255, 0.06);

  tr:hover & {
    background: #111;
  }
`
